import { useTabsContext } from '@hopin-team/ui-tabs';

export const LazyTab = ({
  children,
  index,
}: {
  children: React.ReactElement;
  index: number;
}) => {
  const { selectedIndex, focusedIndex } = useTabsContext();
  return selectedIndex === index || focusedIndex === index ? children : null;
};
